var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b, _c, _d, _e;
import React from 'react';
import { auxilioModule } from '@cognitranlimited/itis-web/dist/auxilio';
import { checkSheetsModule } from '@cognitranlimited/itis-web/dist/check-sheets';
import { joinPath } from './paths';
import { campaignsModule } from '@cognitranlimited/itis-web/dist/campaigns';
import { vehicleParkModule } from '@cognitranlimited/itis-web/dist/vehicle-park';
import { SidebarLogo } from './SidebarLogo';
import { MobileSidebarLogo } from './MobileSidebarLogo';
import { vehicleCodesModule } from './vehicleCodesModule/vehicleCodesModule';
import { vehicleInformationModule } from './vehicleInformationModule/vehicleInformationModule';
import { aosSubscriptionModule } from "./aos-subscription";
import { vehicleSpecificationModule } from './vehicleSpecificationModule/vehicleSpecificationModule';
import { ewdModule } from './ewd/ewdModule';
import { procedureApplicabilityModule } from './procedure-applicability/procedureApplicabilityModule';
import { gieLinksModule } from './gie-links/gieLinksModule';
import { procedureLinksModule } from './procedure-links/procedureLinksModule';
function requireGlobalProperty(key, isOptional) {
    if (isOptional === void 0) { isOptional = false; }
    var property = global.iwaProperties[key];
    if (!isOptional && !property && property !== false) {
        throw new Error("Global property not set: ".concat(key));
    }
    return property;
}
export function getStringsFileLanguage(language) {
    return language.replace(/-/, '');
}
var isProcedureTreeEnabled = requireGlobalProperty('enableNativeDocumentProcedureTree', true);
var isProcedureTreeNavigationBarEnabled = requireGlobalProperty('enableProcedureTreeNavigationBar', true);
export var props = {
    apiUrl: requireGlobalProperty('apiUrl'),
    itisUrl: requireGlobalProperty('itisUrl'),
    authClientId: requireGlobalProperty('authClientId'),
    authSecret: requireGlobalProperty('authSecret'),
    documentAttachmentsS3BucketUrl: requireGlobalProperty('documentAttachmentsS3BucketUrl'),
    brand: 'Nissan',
    vehiclePlateRecognitionEndpoint: joinPath((_a = requireGlobalProperty('vprUrl')) !== null && _a !== void 0 ? _a : '', 'recognize'),
    stringsLoader: function (languageCode) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import(/* webpackChunkName: '[request]' */ "./strings/".concat(languageCode, ".strings"))];
                case 1: return [2 /*return*/, (_a.sent()).default];
            }
        });
    }); },
    helpStringsLoader: function (languageCode) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import(/* webpackChunkName: '[request]' */ "./strings/".concat(languageCode, "Help.strings"))];
                case 1: return [2 /*return*/, (_a.sent()).default];
            }
        });
    }); },
    vehiclePanelOrder: ['notices', 'importantDocuments', 'favouriteContent'],
    hideModelSelectionByDefault: true,
    sidebarLogo: function () { return React.createElement(SidebarLogo, null); },
    mobileSidebarLogo: function () { return React.createElement(MobileSidebarLogo, null); },
    modules: [
        checkSheetsModule(),
        campaignsModule({
            overrides: {
                strings: function (language) {
                    return __awaiter(this, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, import("./strings/campaigns/".concat(getStringsFileLanguage(language), ".strings"))];
                                case 1: return [2 /*return*/, (_b.sent()).default];
                                case 2:
                                    _a = _b.sent();
                                    return [2 /*return*/, null];
                                case 3: return [2 /*return*/];
                            }
                        });
                    });
                }
            }
        }),
        requireGlobalProperty('auxilioUrl', true) ?
            auxilioModule({
                auxilioAppUrl: requireGlobalProperty('auxilioUrl'),
                auxilioSecurityUserRoles: {
                    parts: ['NI_PARTS_TECHNICAL_SUPPORT'],
                    repair: ['NI_REPAIR_TECHNICAL_SUPPORT'],
                    viewer: ['NI_TECHNICAL_SUPPORT_VIEWER']
                },
                overrides: {
                    strings: function (language) {
                        return __awaiter(this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, import("./strings/auxilio/".concat(getStringsFileLanguage(language), ".strings"))];
                                    case 1: return [2 /*return*/, (_b.sent()).default];
                                    case 2:
                                        _a = _b.sent();
                                        return [2 /*return*/, null];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        });
                    }
                }
            }) : undefined,
        vehicleInformationModule(),
        vehicleCodesModule(),
        requireGlobalProperty('enableVehiclePark', true) ? vehicleParkModule({
            vehicleParkApiUrl: requireGlobalProperty('vehicleParkApi')
        }) : undefined,
        aosSubscriptionModule({
            cognitoClientId: requireGlobalProperty('cognitoClientId'),
            cognitoHostedUILogoutUrl: requireGlobalProperty('cognitoHostedUILogoutUrl')
        }),
        vehicleSpecificationModule(requireGlobalProperty('specificationCardDocumentType', true)),
        isProcedureTreeEnabled ? ewdModule() : undefined,
        procedureApplicabilityModule(),
        gieLinksModule(),
        procedureLinksModule()
    ].filter(function (module) { return typeof module !== 'undefined'; }),
    showNonVehicleSidebarDocumentGroups: false,
    showVehicleMetadata: true,
    documentViewEventUrl: requireGlobalProperty('documentEventUrl'),
    hideDocumentHeaderFeedbackButton: (_b = requireGlobalProperty('hideDocumentHeaderFeedbackButton')) !== null && _b !== void 0 ? _b : false,
    getPrintHeader: requireGlobalProperty('getPrintHeader'),
    japaneseVin: {
        pattern: /^[a-zA-Z0-9]{1,10}\s*-\s*\d+$/,
        label: {
            ja: [
                '車台番号を入力し、“検索”をクリックしてください',
                '例：ABC123-123456 (半角のみ)',
                ' ',
                'オーテック仕様車の車台番号を入力しESMを開くとページが表示されない場合があります。',
                'その際は「車名、車系選択」から車両を選択して ESMを閲覧してください。'
            ],
            en: [
                'Please input the VIN and click "Find" button',
                'e.g.: ABC123-123456'
            ]
        }
    },
    enableNlpSearchTextPreview: (_c = requireGlobalProperty('enableNlpSearchTextPreview')) !== null && _c !== void 0 ? _c : false,
    inactivityMaxTime: (_d = requireGlobalProperty('inactivityMaxTime', true)) !== null && _d !== void 0 ? _d : 5400000,
    enableNativeDocumentProcedureTree: isProcedureTreeEnabled,
    enableProcedureTreeNavigationBar: isProcedureTreeNavigationBarEnabled,
    vinFormats: [/^[A-Z0-9]{17}$/, /^[a-zA-Z0-9]{1,10}\s*-\s*\d+$/],
    disableDocumentAutoDownload: true,
    hideVinSearchSuggestion: requireGlobalProperty('hideVinSearchSuggestion', true),
    hideDocumentMetadataSearch: requireGlobalProperty('hideDocumentMetadataSearch', true),
    hiddenAccountTabs: requireGlobalProperty('hiddenAccountTabs', true),
    cognitoHostedUILogoutUrl: (_e = requireGlobalProperty("cognitoHostedUILogoutUrl", true)) !== null && _e !== void 0 ? _e : '',
    enableProactiveRefreshToken: requireGlobalProperty("enableProactiveRefreshToken")
};
